import { BroadLineOfBusiness } from '@app/enumerations';

export default class MinCostPerSquareFoot {
    public broadLineOfBusinessCode: BroadLineOfBusiness | null = null; 
    public stateCode: string | null = null;
    public constructionTypeCode: string | null = null;
    public minCostPerSquareFoot: number = 0;
    public versionId: number = 0;
    public constructor() {

    }
}